import { render } from "./ResetPassword.vue?vue&type=template&id=67197ce2&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=ts"
export * from "./ResetPassword.vue?vue&type=script&lang=ts"

import "./ResetPassword.vue?vue&type=style&index=0&id=67197ce2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-67197ce2"

export default script